import styled from "@emotion/styled";

import { css } from "@emotion/react";

const getPaddingReset = ({ theme, noPaddingReset }) => {
    if (!noPaddingReset) {
        return css`
            & & {
                padding-left: 0;
                padding-right: 0;

                @media (min-width: ${theme.breakpoints.mobileLandscape}) {
                    padding-left: 0;
                    padding-right: 0;
                }
            }
        `;
    }
};

const ContentContainer = styled.div`
    width: 100%;
    padding-left: ${({ theme }) => `${theme.layout.gutter}`};
    padding-right: ${({ theme }) => `${theme.layout.gutter}`};
    margin-left: auto;
    margin-right: auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
        max-width: ${({ theme }) =>
            `calc(${theme.layout.maxContentWidthSmall} + 2 * ${theme.layout.largeGutter})`};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        max-width: ${({ theme }) =>
            `calc(${theme.layout.maxContentWidthMedium} + 2 * ${theme.layout.largeGutter})`};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.largeDesktop}) {
        max-width: ${({ theme }) =>
            `calc(${theme.layout.maxContentWidthLarge} + 2 * ${theme.layout.largeGutter})`};
        padding-left: ${({ theme }) => theme.layout.largeGutter};
        padding-right: ${({ theme }) => theme.layout.largeGutter};
    }

    ${getPaddingReset};
`;

export default ContentContainer;
